<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :color="color_snackbar"
      :label="color_snackbar"
      :value="color_snackbar"
      :top="top_snackbar"
      :right="top_snackbar"
    >
      {{ text_snackbar }}
      <v-btn :color="color_snackbar" dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-tabs dark color="blue darken-4" icons-and-text>
      <v-tab :key="1">
        new job
        <v-icon>done</v-icon>
      </v-tab>

      <v-tab :key="2">
        all done jobs
        <v-icon>done_all</v-icon>
      </v-tab>

      <v-tab-item :key="1">
        <v-card color="blue lighten-2" dark>
          <v-card-title class="headline blue lighten-3">Configure</v-card-title>
          <v-card-text>
            sever name:
            <kbd>{{dataObject.shostname}}</kbd>
          </v-card-text>
          <v-divider></v-divider>
          <v-expand-transition>
            <v-row align="center">
              <v-col cols="6">
                <v-select
                  v-model="select"
                  :hint="`${select.aname}, ${select.adescription}`"
                  :items="items"
                  item-text="aname"
                  item-value="adescription"
                  label="Select job"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-textarea
                  filled
                  auto-grow
                  name="input-11-4"
                  label="EXTRA VARS"
                  value
                  v-model="select.avars"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-expand-transition>
          <v-card-actions>
            <v-btn v-if="select.aid" color="blue darken-4" @click="set_default">
              set default
              <v-icon right>save</v-icon>
            </v-btn>
            <v-btn v-if="select.aid" color="blue darken-4" @click="run_job">
              run job
              <v-icon right>check_circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="2">
        <v-card-title class="headline blue lighten-3">history</v-card-title>

        <v-layout row>
          <v-flex xs12>
            <v-card>
                            <v-btn  color="blue " @click="get_history">
              update list
              <v-icon right>check_circle</v-icon>
            </v-btn>
              <v-list two-line subheader>
                <v-subheader inset>{{dataObject.shostname}}</v-subheader>
                <v-list-item v-for="item in history_list" :key="item.jid" avatar >
                  <v-list-item-avatar>
                    <v-icon :class="[item.iconClass]">playlist_add_check</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.aname}} (run id: {{ item.jrunid }})</v-list-item-title>
                    <v-list-item-sub-title >{{ item.jstatus }} - {{ item.jdate }}</v-list-item-sub-title>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title> {{ item.jvars }}</v-list-item-title>
    <v-dialog v-model="dialog" max-width="1000px">
<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on"  >more</v-btn>
          </template>

        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <pre>{{ item.jvars }}</pre>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
                  </v-list-item-content>

                  <v-list-item-action>
          <a :href="'https://awx.stratis.pro/#/jobs/playbook/'+item.jrunid" target="_blank"><img src="/static/awx.svg" width="50" height="50"></a>

                  </v-list-item-action>
                </v-list-item>

                <v-divider inset></v-divider>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schema: {},
      schema_tmp: {},
      valid: true,
      dataObject: {},
      select: {},
      items: [],
      history_list: [],
      snackbar: false,
      text_snackbar: "saved",
      timeout: 3000,
      color_snackbar: "success",
      top_snackbar: true
    };
  },
  mounted() {

    if (localStorage.getItem("access_token") != null) {
      this.$http.defaults.headers.common[
        "X-Authorization"
      ] = localStorage.getItem("access_token");
    }

    this.$http.get(this.$root.apiUrl + "/api/v1/schemas/servers.json").then(
      response => {
        this.schema_tmp = response.data;

        this.$http
          .get(this.schema_tmp.uri_api + this.$route.params.id)
          .then(response => {
            // console.log(JSON.parse(JSON.stringify(response.data.result)));
            this.dataObject = JSON.parse(JSON.stringify(response.data.result));
          });
      },
      this.$http
        .get(this.$root.apiUrl + "/api/v1/awx/server/"+ this.$route.params.id)
        .then(res => {

          this.items = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false))
    );
    this.get_history();
  },

  methods: {

    set_default: function() {
      this.select.oid = this.dataObject.sid;
      this.select.obj = "server";

      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }
      this.$http
        .post(
          "https://si.stratis.pro/api/v1/awx/awx_set_default_job",
          this.select
        )
        .then(r => {
          // console.log("r: ", JSON.stringify(r, null, 2));
          this.text_snackbar = "save done";
          this.color_snackbar = "success";
          this.snackbar = true;
        })
        .catch(err => {
          this.text_snackbar = "error save";
          this.color_snackbar = "error";
          this.snackbar = true;
          console.log(err);
        });
    },
    run_job: function() {
      this.select.oid = this.dataObject.sid;
      this.select.obj = "server";

      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }
      this.$http
        .post(
          "https://si.stratis.pro/api/v1/awx/awx_run_job",
          this.select
        )
        .then(r => {
          // console.log("r: ", JSON.stringify(r, null, 2));
          this.text_snackbar = "run done";
          this.color_snackbar = "success";
          this.snackbar = true;
          this.get_history();
        })
        .catch(err => {
          this.text_snackbar = "run error";
          this.color_snackbar = "error";
          this.snackbar = true;
          console.log(err);
        });
    },
    initialize() {
      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }

      this.$http
        .get(this.$root.apiUrl + "/api/v1/directory/jobs/")
        .then(res => {
          const { count, entries } = res.data;
          this.count = count;
          this.items = entries;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    get_history() {
      if (localStorage.getItem("access_token") != null) {
        this.$http.defaults.headers.common[
          "X-Authorization"
        ] = localStorage.getItem("access_token");
      }

      this.$http
        .get(this.$root.apiUrl + "/api/v1/awx_history/server/" + this.$route.params.id)
        .then(res => {
          this.history_list = res.data;
          console.log(this.history_list);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/servers/jobs.vue